import Raven from 'raven-js';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CertificateImage as PrivateCertificateImage } from '../../../features/achievementImages';
import { addUrlParams } from 'LearningCenterUI/utils/RoutingUtils';
import { useAchievementTracks, usePublicAchievement } from '../achievementQueries';
import ImageLoader from '../../../components/ImageLoader';
import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const MarketingContainer = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  borderRadius: "300",
  boxShadow: "400",
  "data-test-id": "achievement-cert-image",
  marginBlockStart: "-1000",
  overflow: "hidden",
  children: children
});
const LegacyContainer = ({
  children
}) => {
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    borderRadius: "300",
    boxShadow: "400",
    "data-test-id": "achievement-cert-image",
    marginBlockEnd: isTablet ? '0' : '-700',
    marginBlockStart: "-700",
    overflow: "hidden",
    children: children
  });
};
const handleImageError = ({
  currentTarget
}) => {
  Raven.captureMessage(`Achievements: error loading cert image`, {
    extra: {
      src: currentTarget.src
    }
  });
};
const CertificateImage = ({
  inModal,
  publicId
}) => {
  const {
    publicAchievement
  } = usePublicAchievement(publicId);
  const tracks = useAchievementTracks(publicId);
  const track = tracks !== null && tracks !== void 0 && tracks.length ? tracks[0] : {
    id: null,
    award: {
      certificate: null
    }
  };
  const {
    id: trackId,
    award
  } = track;
  const src = award ? award.certificate : '';
  const maybeTrackedSrc = !inModal && src && !src.match(/^data:/) ? addUrlParams(src, {
    onAchievementsPage: true
  }) : src;
  if (!publicAchievement || !maybeTrackedSrc && !trackId) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "cert-image-wrapper",
      style: {
        aspectRatio: '4/3'
      },
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        title: I18n.text('learningCenter.certification.errors.noCertSrcTitle'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.errors.noCertSrc"
        })
      })
    });
  }
  const Container = getMarketingThemePreference() ? MarketingContainer : LegacyContainer;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx("div", {
      "data-test-id": "cert-image-wrapper",
      style: {
        aspectRatio: '4/3'
      },
      children: /*#__PURE__*/_jsx(ImageLoader, Object.assign({}, publicAchievement.visibilityType === 'PRIVATE' ? {
        trackId,
        component: PrivateCertificateImage,
        key: trackId
      } : {
        src: maybeTrackedSrc,
        key: maybeTrackedSrc
      }, {
        alt: I18n.text('learningCenter.certification.altText'),
        errorComponent: /*#__PURE__*/_jsx(TFlex, {
          alignItems: "center",
          blockSize: "100%",
          justifyContent: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.certification.errors.imgLoadingError"
          })
        }),
        onError: handleImageError
      }))
    })
  });
};
export default CertificateImage;